import { CloseOutlined } from '@ant-design/icons';
import {
  makeIconShape,
  SEXUAL_ACTIVITY_COLORS,
  SEXUAL_ACTIVITY_ICON_PATHS,
} from 'components/charts/SexualActivityChart';

/**
 * Swatches for the vaginal-discharge tracker.
 *
 * This is a categorical scale, not an ordinal one — "creamy" is not more or
 * less than "sticky" — so the colours are chosen to be told apart rather than
 * to form a ramp. They are drawn from across the brand families and separated
 * in lightness as well as hue, so they remain distinguishable to a
 * red/green-colour-blind reader and in greyscale. Each one is reached through
 * a semantic token that carries that exact palette step (coral 600, teal 500,
 * sand 300, mint 200, coral 400).
 *
 * `SPOTTING` is the one entry with a literal association to keep: it stays in
 * the coral family, deep enough to read as blood rather than as decoration.
 */
export const VAGINAL_DISCHARGE_COLORS: Record<string, string> = {
  // Same tone as sexual activity's own "none" (`subtle-foreground`) — not
  // `neutral200`, a background-weight grey that was barely visible as an
  // icon fill.
  NONE: SEXUAL_ACTIVITY_COLORS.NONE,
  SPOTTING: 'var(--destructive)',
  STICKY: 'var(--info)',
  CREAMY: 'var(--border)',
  EGG_WHITE: 'var(--success-border)',
  UNUSUAL: 'var(--chart-3)',
};

// "Aucune" (no discharge) reads better as a small X than as a colour dot — a
// colour can't represent "none" the way it represents every other option —
// so both the calendar scatter and its legend get the same close-icon shape
// the sexual-activity chart already uses for its own "none" value.
const VAGINAL_DISCHARGE_NONE_SHAPE = makeIconShape(
  SEXUAL_ACTIVITY_ICON_PATHS.NONE,
  '64 64 896 896',
  VAGINAL_DISCHARGE_COLORS.NONE,
);
export const VAGINAL_DISCHARGE_SHAPE_MAP = { NONE: VAGINAL_DISCHARGE_NONE_SHAPE };
export const VAGINAL_DISCHARGE_ICON_MAP = {
  NONE: <CloseOutlined className="mr-1 text-xs" style={{ color: VAGINAL_DISCHARGE_COLORS.NONE }} />,
};
